/** ISO calendar date, `YYYY-MM-DD`. */
export type IsoDate = `${number}-${number}-${number}`;
/** Pay month, `YYYY-MM`. */
export type YearMonth = `${number}-${number}`;

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;
const YEAR_MONTH = /^\d{4}-(0[1-9]|1[0-2])$/;

export function isIsoDate(value: string): value is IsoDate {
  const m = ISO_DATE.exec(value);
  if (!m) return false;
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const date = new Date(Date.UTC(y, mo - 1, d));
  return date.getUTCFullYear() === y && date.getUTCMonth() === mo - 1 && date.getUTCDate() === d;
}

export function isYearMonth(value: string): value is YearMonth {
  return YEAR_MONTH.test(value);
}
